import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const AllDifTask = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default AllDifTask
